import { z } from "zod";

import { communityStatusEnum } from "../../enums/community/communityStatus";
import { communityTierEnum } from "../../enums/community/communityTier";
import { communityTypeEnum } from "../../enums/community/communityType";
import { addressSchema } from "../addressSchema";
import { communityMemberSummarySchema } from "./communityMemberSummarySchema";
import { communitySharingDefaultsSchema } from "./communitySharingDefaultsSchema";

const parentDetailsSchema = z.object({
  id: z.number(),
  image_url: z.string().nullable(),
  color_hex: z.string().nullable(),
  name: z.string(),
  is_member: z.boolean(),
});

const communityContractSchema = z.object({
  id: z.number(),
  package_tier: communityTierEnum,
  start_date: z.iso.datetime(),
  code: z.string().nullable(),
  total_challenge_tokens: z.number().nullable(),
  challenge_tokens_remaining: z.number().nullable(),
});

export const communitySchema = z.object({
  id: z.number(),
  description: z.string().nullable(),
  image_url: z.string().nullable(),
  color_hex: z.string().nullable(),
  address: addressSchema.nullable(),
  name: z.string(),
  status: communityStatusEnum.nullable(),
  launched_at: z.iso.datetime().nullable(),
  type: communityTypeEnum,
  created_at: z.iso.datetime(),
  updated_at: z.iso.datetime(),
  is_non_admin_content_allowed: z.boolean().nullable().optional(),
  address_label: z.string(),
  simple_address_label: z.string(),
  member_summary: communityMemberSummarySchema,
  is_nonadmin_content_allowed: z.boolean(),
  sharing_defaults: communitySharingDefaultsSchema,
  is_admin: z.boolean(),
  has_requested_admin: z.boolean(),
  role_id: z.number().nullable(),
  parent_community_id: z.number().nullable(),
  parent_details: parentDetailsSchema.nullable(),
  tag_text: z.string().nullable(),
  current_contract: communityContractSchema.nullable(),
  remove_global_challenges: z.boolean(),
  is_private_group_feature_available: z.boolean().nullable(),
  is_private: z.boolean(),
  legal_nonprofit_name: z.string().nullable(),
});

export type Community = z.infer<typeof communitySchema>;
